import { fetchConToken } from "../helpers/fetch";
import { Alert } from 'rsuite';
import { types } from "../types/types";
import { clientLoadRoom } from "./client";

export const loadPartner = ()=>{
    return async(dispatch)=>{
        try {
            const resp = await fetchConToken('habitacion/companeros');
            const companeros = await resp.json();
            await dispatch( partnerLoading(companeros) );
            
        } catch (error) {
            console.log(error);
        }
        
    }
}

const partnerLoading =(companeros)=>({
    type: types.roomsLoadingList,
    payload: companeros,
})

export const deletePartner = (folio) => ({
    type: types.roomsDeleteFolio,
    payload: folio,
})

export const addPartner = (cliente) => ({
    type: types.roomsAddFolio,
    payload: cliente,
})

export const submitPartners = (companeros) => {
    return async(dispatch)=>{
        const resp = await fetchConToken('habitacion/crear', companeros, 'POST', 'json');
        const body = await resp.json();
        if(!body.ok){
            Alert.error(body.message, 5000);
        }else {
            Alert.success('Habitacion creada correctamente.', 5000);
            await dispatch( clientLoadRoom(body.room_id) );
        };
    }
}